export const CREATE_GROUP = "CREATE_GROUP";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const CREATE_GROUP_FAILED = "CREATE_GROUP_FAILED";
export const CREATE_GROUP_RESET_STATE = "CREATE_GROUP_RESET_STATE";

export const createNewGroup = (payload) => {
  return {
    type: CREATE_GROUP,
    payload,
  };
};

export const createNewGroupSuccess = (payload) => {
  return {
    type: CREATE_GROUP_SUCCESS,
    payload,
  };
};

export const createNewGroupFailed = (payload) => {
  return {
    type: CREATE_GROUP_FAILED,
    lockedUserMessage:
      "A previous network change is still in process. Please try again later",
    payload,
  };
};

export const resetCreateGroupState = () => {
  return {
    type: CREATE_GROUP_RESET_STATE,
  };
};
